(function () {
    'use strict';

    angular
        .module('iamSystemModule')
        .directive('iamSystem', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {
        var directiveScope = _.clone(boxTmplScope);
        directiveScope.onSelect = '&';
        directiveScope.onRemove = '&';
        directiveScope.withIcon = '&';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$scope', '$controller',
                function ($scope, $controller) {

                    // Box Template
                    $scope.baseTemplatePath = '/app/shared/iamSystem/iamSystem.[Template].tpl.html';

                    // Permissions default values
                    $scope.boxFeatureRole = $scope.boxFeatureRole || 'BIAProfileManagement';
                    $scope.boxPermissionKey = $scope.boxPermissionKey || 'BIAProfile';

                    $scope.withIcon = $scope.withIcon() !== false;

                    $controller('BoxTmplController', { $scope: $scope });
                }],
            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);

                if (!_.isUndefined(attrs.onSelect)) scope.showOnSelectAction = true;
                if (!_.isUndefined(attrs.onRemove)) scope.showOnRemoveAction = true;
            }
        }
    }
})();
